/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-04-25 09:50:49
 * @LastEditTime: 2019-08-23 15:17:21
 * @LastEditors: Please set LastEditors
 */
import axios from 'axios'
// import { Message, MessageBox } from 'element-ui'
import { Toast } from 'vant';
import store from '../store'
import { getToken, removeToken, removeCookie, getCookie } from '@/utils/auth'
import qs from 'qs'
import * as configs from '@/../config/config'
import Router from '@/router/index'
import Vue from "vue";
// import jsonlint from './jsonlint'
// 创建axios实例
const service = axios.create({
    baseURL: configs[configs.Edition].axiosUrl, // api的base_url
    timeout: 50000, // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
    config => {

        if (config.method === 'post' || config.method === 'put') {
            if (config.headers['Content-Type'] === 'application/json; charset=UTF-8') {

            } else if (config.headers.post['Content-Type'] === 'application/x-www-form-urlencoded') {
                config.data = qs.stringify(config.data)
            }
        }

        if (config.method === 'get') {
            if (config.data) {
                Object.keys(config.data).forEach(function (key) {
                    if (config.data[key] == '') {
                        config.data[key] = undefined
                    }
                });
                config.url += '?' + qs.stringify(config.data)
            }
        }
        config.headers['Accept-Language'] = getCookie('language') ? getCookie('language') : 'en'

        if (getToken()) {
            config.headers['token'] = getToken()
        } // 让每个请求携带自定义token 请根据实际情况自行修改
        config.headers['client'] = '1' // 1=web 2=ios 3=android
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)

// respone拦截器
service.interceptors.response.use(
    response => {
        /**
         * code为非20000是抛错 可结合自己业务进行修改
         */
        const res = response.data
        if (response.status === 200) {  
            if (res.code == 404) {
                location.href = configs.linkUrl + '/fail' // 404 页面
                return false
            }
            // if (res.code === 403 || res.code === 413) {
            //     removeToken()
            //     removeCookie('userInfo')
            //     // setTimeout(() => {
            //     //   Router.push('/login')
            //     // }, 3000)
            // }

            if (window.location.href.includes('isApp=1')) {

              if (res.code === 403 || res.code === 413) {
                removeToken()
                removeCookie('userData')
                store.dispatch('FedLogOut')
                // console.log(response,'403了')
                // Toast({
                //     message: res.msg
                // });
                // Toast(res.code)
                Vue.prototype.$jsBridge.callHandler(Vue.prototype.$jsBridgeCmd.appLogout, {}, (data) => {
                })
                setTimeout(() => {
                    Vue.prototype.$jsBridge.callHandler(Vue.prototype.$jsBridgeCmd.appLogin, {code: 200, type: 'login'}, (data) => {
                    })
                  }, 2000)

                // setTimeout(() => {
                    // Vue.prototype.$jsBridge.callHandler(
                    //     Vue.prototype.$jsBridgeCmd.appLogin, {code: 200, type: 'login',url:'/purchase'}, (data) => {}
                    //   );
                //   }, 3000)
                // return;
              }
            } else {
              if (res.code === 403 || res.code === 413) {
                removeToken();
                removeCookie('userData');
                // console.log(Vue.prototype)
                store.dispatch('FedLogOut')
                // setTimeout(() => {
                  console.log(Router,'jinlaile')
                  Router.push('/login?historyBack=' + window.encodeURIComponent(Router.history._startLocation))
                // }, 3000)
              }
            }
            // if (res.code && res.code !== 200 && res.code !== 20000 && res.code !== 511 && res.code !== 201) {
            //   Toast({
            //     message: res.msg
            //   });
            //   // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
            //
            //   return Promise.reject('error')
            // }
        }

        if (response.config.url.indexOf('/login') != -1) {
            return response
        } else if (response.config.url.indexOf('/img-code') != -1) {
            return response
        } else if (response.config.url.indexOf('/dynamic-auth') != -1) {
            return response
        } else if (response.config.url.indexOf('/register') != -1) {
            return response
        } else if (response.config.url.indexOf('/validation/online') != -1) {
            return response
        } else if (response.config.url.indexOf('/blind-box/draw') != -1) {
            return response
        }else if(response.config.url.indexOf('/v3/mall/order')!=-1&&response.config.method=='post'){
            return response.data
        }else if(response.config.url.indexOf('/c2c/v3/third-party/order')!= -1 && response.config.method=='post'){
          return response.data
        }else if (response.config.url.indexOf('/v3/check-limit') != -1) {
            return response.data
        }else if (response.config.url.indexOf('/v3/check/overhead') != -1 && response.config.method == 'post') {
            return response.data
        }else if (response.config.url.indexOf('/v3/check-memo') != -1 && response.config.method == 'post') {
            return response.data
        }else if (response.config.url.indexOf('/v3/create-memo') != -1 && response.config.method == 'post'){
            return response.data
        }else if (response.config.url.indexOf('/v3/create-memo/exist') != -1 && response.config.method == 'post') {
            return response.data
        }else if (response.config.url.indexOf('/v3/upload/ten-img')) {
            return response.data
        }
        if (res.code && res.code !== 200 && res.code != 413 && res.code != 403 && res.code != 121022 && res.code != 121021 && res.code != 121023 && res.code != 20002 && res.code != 51013 && res.code != 51011) {
            if (response.config.url.indexOf('/validation/online/') == -1) {
                Toast({
                    message: res.msg
                });
            }
            return Promise.reject('error')
        }
        return response.data
    },
    error => {
        // Toast({
        //     message: error.msg
        // });
        return Promise.reject(error)
    }
)
axios.defaults.withCredentials = true
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js